import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, Button, Message } from '@weezevent/nacre';
import LoadingCard from '../../components/loadingCard';
import { ContingentQuota, CategoryQuota } from '../placement/map';

export default function AvailabilityQuotaCard({
    display,
    loadingAvailability,
    availabilityError,
    fetchAvailability,
    currentAvailability,
    contingents,
    categories,
    event,
    organization,
    inventory
}) {
    const { t } = useTranslation();

    return (
        <Card>
            <Card.Header>
                <Card.Title title={display === 'contingents' ? t('ticket.availability.titleListContingents') : t('ticket.availability.titleListCategories')} />
            </Card.Header>
            <Card.Content>
                <LoadingCard loading={loadingAvailability}>
                    {availabilityError ? (
                        <Message type="danger" title={t('ticket.availability.error_title')}>
                            <p>{t('ticket.availability.error_message')}</p>
                            <Button inverted onClick={() => fetchAvailability()} isLoading={loadingAvailability}>
                                {t('ticket.availability.error_retry')}
                            </Button>
                        </Message>
                    ) : (
                        <>
                            {display === 'contingents' && (
                                <ContingentQuota availability={currentAvailability} contingents={contingents} event={event} organization={organization} inventory={inventory} />
                            )}
                            {display === 'categories' && (
                                <CategoryQuota availability={currentAvailability} categories={categories} event={event} organization={organization} inventory={inventory} />
                            )}
                        </>
                    )}
                </LoadingCard>
            </Card.Content>
        </Card>
    );
}

AvailabilityQuotaCard.propTypes = {
    display: PropTypes.string.isRequired,
    loadingAvailability: PropTypes.bool.isRequired,
    availabilityError: PropTypes.bool.isRequired,
    fetchAvailability: PropTypes.func.isRequired,
    currentAvailability: PropTypes.object,
    contingents: PropTypes.array,
    categories: PropTypes.array,
    event: PropTypes.object.isRequired,
    organization: PropTypes.object.isRequired,
    inventory: PropTypes.object
};
